import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import "./app.scss";
import Spinner from "./imgs/spinner.svg";
import { Home } from "./home/index.jsx";
import { PastEditions } from "./edition/list.jsx";
import { EditionDetails } from "./edition/index.jsx";

const renderLoader = () => /*#__PURE__*/React.createElement("img", {
  src: Spinner,
  alt: "Loading"
});

const renderError = () => /*#__PURE__*/React.createElement("p", null, "Something went wrong");

const App = () => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [config, setConfig] = useState({});
  useEffect(() => {
    fetch("./app.json").then(res => res.json()).then(result => {
      setIsLoaded(true);
      setConfig(result);
    }, error => {
      setIsLoaded(false);
      setError(error);
    });
  }, []);
  if (!isLoaded) return renderLoader();

  if (error || !config.name) {
    return renderError();
  }

  return /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(Home, {
    config: config
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/edition"
  }, /*#__PURE__*/React.createElement(EditionDetails, {
    config: config
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/list"
  }, /*#__PURE__*/React.createElement(PastEditions, {
    config: config
  })), /*#__PURE__*/React.createElement(Redirect, {
    to: "/"
  })));
};

ReactDOM.render( /*#__PURE__*/React.createElement(App, null), document.getElementById("root"));